import { createBrowserRouter, type RouteObject } from "react-router";
import { AppFrame } from "./AppFrame";
import { RequireSession } from "./RequireSession";
import { RootRedirect } from "./RootRedirect";
import { RouteError } from "./RouteError";

// Every screen and every portal is its own chunk: a doctor never downloads the company portal and vice versa.
const page = (load: () => Promise<{ Component: React.ComponentType }>) => ({ lazy: load });

const routes: RouteObject[] = [
  {
    element: <AppFrame />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <RootRedirect /> },
      { path: "login", ...page(() => import("../pages/auth/LoginPage").then((m) => ({ Component: m.LoginPage }))) },
      { path: "login/code", ...page(() => import("../pages/auth/CodePage").then((m) => ({ Component: m.CodePage }))) },
      { path: "invite/:token", ...page(() => import("../pages/invite/InvitePage").then((m) => ({ Component: m.InvitePage }))) },
      { path: "status", ...page(() => import("../pages/status/StatusPage").then((m) => ({ Component: m.StatusPage }))) },
      {
        element: <RequireSession />,
        children: [
          { path: "welcome", ...page(() => import("../pages/welcome/WelcomePage").then((m) => ({ Component: m.WelcomePage }))) },
          { path: "select-workspace", ...page(() => import("../pages/select-workspace/SelectWorkspacePage").then((m) => ({ Component: m.SelectWorkspacePage }))) },
          { path: "pending", ...page(() => import("../pages/pending/PendingPage").then((m) => ({ Component: m.PendingPage }))) },
          { path: "onboarding/*", ...page(() => import("../pages/onboarding/OnboardingPage").then((m) => ({ Component: m.OnboardingPage }))) },
          { path: "company/*", ...page(() => import("../portals/company/CompanyPortal").then((m) => ({ Component: m.CompanyPortal }))) },
          { path: "clinical/*", ...page(() => import("../portals/clinical/ClinicalPortal").then((m) => ({ Component: m.ClinicalPortal }))) },
        ],
      },
      { path: "*", ...page(() => import("../pages/not-found/NotFoundPage").then((m) => ({ Component: m.NotFoundPage }))) },
    ],
  },
];

export const router = createBrowserRouter(routes);
